<button class="modal-close" (click)="close()"></button>
<h4
  class="modal-title"
  *ngIf="!shift.name"
  i18n="Modal|Title for create shift settings modal @@modalShiftSettingsAddTitle"
>
  Add a Shift
</h4>
<h4
  class="modal-title"
  *ngIf="shift.name"
  i18n="Modal|Title for editing shift settings modal @@modalShiftSettingsEditTitle"
>
  Edit Shift - {{ data.shift.name }}
</h4>
<div class="modal-content">
  <form #shiftSettingForm="ngForm" name="shiftSettingsForm">
    <div class="u-layout-grow">
      <ls-text
        [label]="'Name'"
        [placeHolder]="'Shift name'"
        [required]="true"
        [name]="'name'"
        [ngModel]="shift.name"
      ></ls-text>
    </div>
    <div class="o-layout__item c-section__right u-layout-grow side-by-side">
      <div class="c-form__item u-layout-auto u-width-50">
        <label
          for="shift-setting-start-time"
          i18n="Label|Label shiftSettingStartTime @@labelShiftSettingStartTime"
          >Start Time</label
        >
        <ls-time-form [formGroup]="shiftStartGroup"></ls-time-form>
      </div>
      <div class="c-form__item u-layout-auto u-width-50">
        <label
          for="shift-setting-end-time"
          i18n="Label|Label shiftSettingEndTime @@labelShiftSettingEndTime"
          >End Time</label
        >
        <ls-time-form [formGroup]="shiftEndGroup"></ls-time-form>
      </div>
    </div>
  </form>
  <div class="error">{{ error }}</div>
</div>
<div class="modal-footer">
  <button
    type="button"
    name="button"
    class="o-button o-button--default"
    (click)="close()"
    i18n="Button|Cancel Button @@buttonCancel"
  >
    Cancel
  </button>
  <button
    type="button"
    name="button"
    class="o-button o-button--success"
    [disabled]="!shiftSettingForm.valid"
    (click)="save(shiftSettingForm)"
    i18n="Button|Save Button @@buttonSave"
  >
    Save
  </button>
</div>
